// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-dropdown{background:#fff!important;border:1px solid rgba(31,36,48,.2)!important;color:#1f2430!important;font-weight:400!important;padding:0 1em;width:10.625rem;justify-content:space-between!important}.custom-dropdown+.dropdown-menu{min-width:100%}", ""]);
// Exports
module.exports = exports;
